import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../api';
import PatientSituationtransfercaseModal from './TransferCaseModal/PatientSituationtransfercase';
import RejectionModal from './TransferbuttonModal/RejectionModal';
import TopBar from '../../Tools/Topbar';
import LeftSide from '../../Tools/LeftSidebar';
import Settings from '../../Tools/Setting/Settings';
import useSettings from '../../Tools/Setting/useSettings';
import { format, parseISO } from 'date-fns';

// Component to fetch and store date and time formats in sessionStorage
const DateTimeFormatFetcher = () => {
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axiosInstance.get('/ems/get-system-setting', {});
        if (res.data?.status === 'success' && res.data.data.length > 0) {
          const data = res.data.data[0];
          sessionStorage.setItem('date_format', data.date_format || 'DD/MM/YYYY');
          sessionStorage.setItem('time_format', data.time_format || '24');
        }
      } catch (err) {
        console.error('Error fetching date and time formats:', err);
        sessionStorage.setItem('date_format', 'DD/MM/YYYY');
        sessionStorage.setItem('time_format', '24');
      }
    };
    fetchSettings();
  }, []); // Run once on mount

  return null; // No UI to render
};


const TransferDetailsTab = () => {
    const [caseId, setCaseId] = useState(sessionStorage.getItem('currentCaseId'));
      const userId = sessionStorage.getItem('user_id'); 
      const [roleId] = useState(sessionStorage.getItem('Role_id'));
      const [userRoleName] = useState(sessionStorage.getItem('Role_Name'));
      const [caseData, setCaseData] = useState(null);
      const [isLoading, setIsLoading] = useState(true);
      const [error, setError] = useState(null);
      const [showAcknowledge, setShowAcknowledge] = useState(false);
      const [showApprove, setShowApprove] = useState(false);
      const [isApproving, setIsApproving] = useState(false);
      const [showReject, setShowReject] = useState(false);
      const [isRejecting, setIsRejecting] = useState(false);
      const [showRejectionModal, setShowRejectionModal] = useState(false);
      const [selectedDocument, setSelectedDocument] = useState(null);
      const [showDocumentModal, setShowDocumentModal] = useState(false);
      const [isPatientModalOpen, setIsPatientModalOpen] = useState(false);
      const [patientSituationData, setPatientSituationData] = useState(null);

    

      const navigate = useNavigate();
      const settingsRef = useRef(null);
      const { settings, updateSetting, handleColorTheme } = useSettings();
      const [isSidebarOpen, setIsSidebarOpen] = useState(true);
      const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Utility function to format date based on settings
    const formatCaseDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const dateFormat = sessionStorage.getItem('date_format') || 'DD/MM/YYYY';
      const timeFormat = sessionStorage.getItem('time_format') || '24';
  
      // Map WordPress-style formats to date-fns syntax
      const dateFormatMap = {
        'DD/MM/YYYY': 'dd/MM/yyyy',
        'MM/DD/YYYY': 'MM/dd/yyyy',
        'YYYY-MM-DD': 'yyyy-MM-dd',
      };
  
      const timeFormatString = timeFormat === '12' ? 'hh:mm:ss a' : 'HH:mm:ss';
      const formatString = `${dateFormatMap[dateFormat] || 'dd/MM/yyyy'} ${timeFormatString}`;
  
      // ✅ Parse both ISO and non-ISO timestamps as *UTC*, not local time
      let utcDate;
      if (dateString.includes('T')) {
        // ISO 8601 with timezone (e.g. 2025-10-27T16:27:19.000000Z)
        utcDate = new Date(dateString);
      } else {
        // MySQL-like (e.g. 2025-10-27 16:35:40)
        utcDate = new Date(dateString.replace(' ', 'T') + 'Z'); // force UTC
      }
  
      // Format without applying local timezone
      const utcTimestamp = new Date(
        utcDate.getUTCFullYear(),
        utcDate.getUTCMonth(),
        utcDate.getUTCDate(),
        utcDate.getUTCHours(),
        utcDate.getUTCMinutes(),
        utcDate.getUTCSeconds()
      );
  
      return format(utcTimestamp, formatString);
    } catch (err) {
      console.error('Error formatting date:', err, dateString);
      return 'Invalid Date';
    }
  };

  // API: Reject Case
    const handleReject = async (disapprovalNotes) => {
      try {
        setIsRejecting(true);
  
        if (!caseId) {
          showAlert('No case ID found.', false);
          return;
        }
        if (!caseData?.doctor?.id) {
          showAlert('No doctor ID found for this case.', false);
          return;
        }
  
        const token = sessionStorage.getItem('auth_token');
        if (!token) {
          showAlert('No authentication token found. Please log in.', false);
          navigate('/login');
          return;
        }
  
        const formData = new URLSearchParams();
        formData.append('case_id', caseId);
        formData.append('disapproval_notes', disapprovalNotes);
  
        const res = await axiosInstance.post('/ems/disapproved-by-doctor', formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/vnd.api+json',
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (res.status === 200) {
          const msg = res.data?.message;
          showAlert(msg);
          if (msg.toLowerCase().includes('disapproved')) {
            setCaseData((prev) => ({
              ...prev,
              doctor_approval_status: 'Rejected',
            }));
            setShowApprove(false);
            setShowReject(false);
          }
        }
      } catch (err) {
        console.error('Error disapproving case:', err);
        showAlert(err.response?.data?.message || 'Failed to disapprove case', false);
      } finally {
        setIsRejecting(false);
        setShowRejectionModal(false);
      }
    };

    

  // API: Acknowledge Case
    const handleAcknowledge = async () => {
      try {
        if (!caseId) {
          showAlert('No case ID found.', false);
          return;
        }
        const token = sessionStorage.getItem('auth_token');
        if (!token) {
          showAlert('No authentication token found. Please log in.', false);
          navigate('/login');
          return;
        }
  
        const formData = new URLSearchParams();
        formData.append('case_id', caseId);
  
        const res = await axiosInstance.get(`/ems/case-acknowledgement/${caseId}`, formData);
  
        if (res.status === 200) {
          showAlert('Successfully acknowledged');
          setCaseData((prev) => ({ ...prev, acknowledgment: 'Acknowledged' }));
          setShowAcknowledge(false);
        }
      } catch (err) {
        console.error('Error acknowledging case:', err);
        showAlert(err.response?.data?.message || 'Failed to acknowledge case', false);
      }
    };

    // API: Fetch Acknowledge Button Status
      const fetchButtonStatus = async () => {
        try {
          if (!caseId || !sessionStorage.getItem('auth_token')) {
            setShowAcknowledge(false);
            return;
          }
          const res = await axiosInstance.get(`/ems/show-case-acknowledgement/${caseId}/${userId}`);
          setShowAcknowledge(res.data?.show_button === true);
        } catch (err) {
          console.error('Error fetching acknowledge button status:', err);
          setShowAcknowledge(false);
        }
      };

      // API: Fetch Approve Button Status
        const fetchApproveButtonStatus = async () => {
          try {
            if (!caseId || !sessionStorage.getItem('auth_token')) {
              setShowApprove(false);
              setShowReject(false);
              return;
            }
            const res = await axiosInstance.get(`/ems/show-case-approved/${caseId}`, {
              headers: {
                Accept: 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
                Authorization: `Bearer ${sessionStorage.getItem('auth_token')}`,
              },
            });
            setShowApprove(res.data?.show_button === true);
            setShowReject(res.data?.show_button === true);
          } catch (err) {
            console.error('Error fetching approve button status:', err);
            setShowApprove(false);
            setShowReject(false);
          }
        };

    // API: Approve Case
      const handleApprove = async () => {
        try {
          setIsApproving(true);
    
          if (!caseId) {
            showAlert('No case ID found.', false);
            return;
          }
          if (!caseData?.doctor?.id) {
            showAlert('No doctor ID found for this case.', false);
            return;
          }
    
          const token = sessionStorage.getItem('auth_token');
          if (!token) {
            showAlert('No authentication token found. Please log in.', false);
            navigate('/login');
            return;
          }
    
          const formData = new URLSearchParams();
          formData.append('case_id', caseId);
          formData.append('doctor_id', caseData.doctor.id);
          console.log('formData:', formData.toString());
    
          const res = await axiosInstance.post('/ems/approved-by-doctor', formData, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Accept: 'application/vnd.api+json',
              Authorization: `Bearer ${token}`,
            },
          });
    
          if (res.status === 200) {
            const msg = res.data?.message;
            showAlert(msg);
            if (msg.toLowerCase().includes('approved')) {
              setCaseData((prev) => ({
                ...prev,
                doctor_approval_status: 'Approved',
              }));
              setShowApprove(false);
              setShowReject(false);
              // Refresh the page after successful approval
              window.location.reload();
            }
          }
        } catch (err) {
          console.error('Error approving case:', err);
          showAlert(err.response?.data?.message || 'Failed to approve case', false);
        } finally {
          setIsApproving(false);
        }
      };

      useEffect(() => {
  const storedCaseId = sessionStorage.getItem('currentCaseId');
  if (storedCaseId && storedCaseId !== caseId) {
    setCaseId(storedCaseId);
  }
}, []);

// Add this NEW useEffect
useEffect(() => {
  if (caseId) {
    fetchTransferCaseDetails();
  } else {
    setError('No case ID found in session');
  }
}, [caseId]); // Re-run when caseId changes

    // API: Fetch Transfer Case Details
    const fetchTransferCaseDetails = async () => {
          try {
            setIsLoading(true);
        if (!caseId) {
          setError('No transfer case selected');
          return;
        }

        const token = sessionStorage.getItem('auth_token');
        if (!token) {
          navigate('/login');
          return;
        }

        const res = await axiosInstance.get(`/ems/cases/${caseId}`, {
          headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            Authorization: `Bearer ${token}`,
          },
        });

        // FIX HERE: Extract the actual case object
        const actualCaseData = res.data?.data || res.data || null;
        
        if (!actualCaseData) {
          setError('Case data not found in response');
          setCaseData(null);
          return;
        }

        setCaseData(actualCaseData);
        setError(null);

        // Also fetch patient situation after case loads
        fetchPatientSituationData();
        fetchButtonStatus();
        fetchApproveButtonStatus();

      } catch (err) {
        console.error('Error fetching transfer case details:', err);
        setError(
          err.response?.data?.message ||
          err.response?.data?.error ||
          'Failed to load case details'
        );
        if (err.response?.status === 401) navigate('/login');
      } finally {
        setIsLoading(false);
      }
    };

       // Document handling
  const getDocuments = () => {
    if (!caseData) return [];
    return ['documents1', 'documents2', 'documents3']
      .map((key) => caseData[key])
      .filter((doc) => doc && doc.trim() !== '');
  };

  // API: Fetch Patient Situation Data
  const fetchPatientSituationData = async () => {
    try {
      if (!caseId || !sessionStorage.getItem('auth_token')) {
        return;
      }
      const response = await axiosInstance.get(`/ems/get-transfer-case-patient-situation/${caseId}`, {
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          Authorization: `Bearer ${sessionStorage.getItem('auth_token')}`,
        },
      });
      setPatientSituationData(response.data[0] || {});
    } catch (err) {
      console.error('Error fetching patient situation data:', err);
      setPatientSituationData({});
    }
  };

  
  
  const tableFields = [
    { label: 'ID', value: caseData?.id || 'N/A' },
    { label: 'Name', value: caseData?.case_name || 'N/A' },
    { label: 'Transfer From', value: caseData?.from_medical_center?.name || 'N/A' },
    { label: 'Transfer To', value: caseData?.medical_center?.name || 'N/A' },
    { label: 'Ambulance', value: caseData?.ambulance?.plate_number || 'N/A' },
    { label: "Clinic No", value: caseData?.patient_situation?.clinic_no || "N/A" },
    { label: "Request Details", value: caseData?.patient_situation?.request_details || "N/A" },
    { label: "Escort Team(Physician)", value: caseData?.patient_situation?.escort_team?.escort_physician || "N/A" },
    { label: "Escort Team(Nurse)", value: caseData?.patient_situation?.escort_team?.escort_nurse || "N/A" },
    { label: "Escort Team(Paramedic)", value: caseData?.patient_situation?.escort_team?.escort_paramedic || "N/A" },
    { label: "Escort Team(Other)", value: caseData?.patient_situation?.escort_team?.other || "N/A" },

    { label: 'Paramedics ID', value: caseData?.ems_member || 'N/A' },
    { label: 'Paramedics Name', value: caseData?.ems_member_name || 'N/A' },
    { label: 'Paramedics Status', value: caseData?.ems_team_status ? 'Busy' : 'Available' },
    { label: 'Nurse ID', value: caseData?.nurse?.id || 'N/A' },
    {
      label: 'Nurse Name',
      value: caseData?.nurse
        ? `${caseData.nurse.first_name || ''} ${caseData.nurse.last_name || ''}`.trim()
        : 'N/A'
    },
    { label: 'Doctor ID', value: caseData?.doctor?.id || 'N/A' },
    { 
      label: 'Doctor Name', 
      value: caseData?.doctor
        ? `${caseData.doctor.first_name || ''} ${caseData.doctor.last_name || ''}`.trim()
        : 'N/A'
    },
    { 
      label: 'Doctor Approval Status', 
      value: caseData?.doctor_approval_status === 1 
        ? 'Approved' 
        : caseData?.doctor_approval_status === 2 
          ? 'Pending' 
          : caseData?.doctor_approval_status === 'Rejected' 
            ? 'Rejected'
            : 'Pending' 
    },
    { label: 'Gender', value: caseData?.gender || 'N/A' },
    { label: 'Age', value: caseData?.age || 'N/A' },
    { label: 'Bracelet ID', value: caseData?.bracelet_id || 'N/A' },
    { label: 'Diagnose', value: caseData?.diagnose || 'N/A' },
    { label: 'Contact Number', value: caseData?.contact_number || 'N/A' },
    { label: 'Acknowledgment', value: caseData?.acknowledgment || 'Pending' },
    {
      label: 'Documents',
      value: (
        <p className="mb-0 fw-normal">
          <i className="ti ti-paperclip me-2"></i>
          {getDocuments().length > 0 ? (
            getDocuments().map((doc, index) => (
              <button
                key={index}
                type="button"
                className="btn btn-link me-3 p-0"
                onClick={() => handleDocumentClick(doc)}
                title={`Document ${index + 1}`}
              >
                <i className="ti ti-library-photo"></i>
              </button>
            ))
          ) : (
            'No documents'
          )}
        </p>
      ),
    },
    { 
      label: 'Case Date', 
      value: caseData?.created_at ? formatCaseDate(caseData.created_at) : 'N/A' 
    },
    {
      label: 'Patient Situation',
      value: (
        <p className="mb-0 fw-normal">
          <button
            className="text-primary bg-transparent border-0 p-0"
            onClick={() => {
              console.log('Patient Situation button clicked, caseId:', caseId);
              handleViewPatientSituation();
            }}
          >
            Click to view details
          </button>
        </p>
      ),
    },
  ];
const showAlert = (msg, success = true) => alert(`${success ? 'Success:' : 'Error:'} ${msg}`);



  const handleViewPatientSituation = () => {
    if (!caseId) {
      showAlert('No case ID found.', false);
      console.error('handleViewPatientSituation: caseId is missing');
      return;
    }
    console.log('handleViewPatientSituation: Opening PatientSituationModal with caseId:', caseId);
    sessionStorage.setItem('currentCaseId', caseId);
    setIsPatientModalOpen(true);
  };

 
  

  const handleDocumentClick = (url) => {
    setSelectedDocument(url);
    setShowDocumentModal(true);
  };

  

  const renderDocumentContent = (url) => {
    const ext = url.split('.').pop().toLowerCase();
    if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)) {
      return <img src={url} alt="attachment" className="w-100" style={{ maxHeight: '500px', objectFit: 'contain' }} />;
    }
    if (['pdf', 'xml'].includes(ext)) {
      return <iframe src={url} width="100%" height="500px" title="Document" />;
    }
    return <p>Unsupported file type: {ext}</p>;
  };

  // Callback for refreshing data after modal save
  const handlePatientModalSave = () => {
    console.log('handlePatientModalSave: Refreshing TransferDetailsTab data');
    fetchTransferCaseDetails();
    fetchPatientSituationData();
  };

  

  return (
  <div id="main-wrapper">
    <DateTimeFormatFetcher />
    <LeftSide isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

    <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
      <TopBar toggleSidebar={toggleSidebar} />

      <div className="body-wrapper">
        <div className="container-fluid">
          <Settings
            ref={settingsRef}
            updateSetting={updateSetting}
            handleColorTheme={handleColorTheme}
            settings={settings}
          />

          <div className="card w-100 position-relative overflow-hidden">
            <div className="px-4 py-3">
              <h5 className="card-title fw-semibold mb-0 lh-sm">Transfer Case Detail</h5>
              <p className="card-subtitle mb-0 mt-1">
                Detailed view of the patient transfer record, including personnel, medical, and case-specific information.
                Manage updates, view attached documents, and assess patient condition in real-time.
              </p>
            </div>

            <div className="card-body p-4">
              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : error ? (
                // Optional: Error state inside card
                <div className="alert alert-danger text-center">
                  {error}
                  <button
                    className="btn btn-primary btn-sm ms-3"
                    onClick={() => {
                      setError(null);
                      setIsLoading(true);
                      fetchTransferCaseDetails();
                    }}
                  >
                    Retry
                  </button>
                </div>
              ) : (
              <>
              <div className="py-3 px-0">
                <div className="table-responsive rounded-2 ros-table">
                  <table className="table text-nowrap customize-table mb-0 align-middle">
                    <thead className="text-dark fs-4">
                      <tr>
                        <th><h6 className="fw-semibold mb-0">Field</h6></th>
                        <th><h6 className="fw-semibold mb-0">Value</h6></th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableFields.map((field, index) => (
                        <tr key={index}>
                          <td><p className="mb-0 fw-normal fw-semibold">{field.label}</p></td>
                          <td>{field.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Buttons Panel */}
                <div className="btn-panel pt-4">
                  {(userRoleName === 'Hospital Representative (Nurse)' ||
                    userRoleName === 'EMS Team') &&
                    showAcknowledge &&
                    caseData.acknowledgment !== 'Acknowledged' && (
                      <button
                        type="button"
                        className="btn mb-1 me-4 waves-effect waves-light btn-rounded btn-success"
                        onClick={handleAcknowledge}
                      >
                        Acknowledge
                      </button>
                    )}

                  {(userRoleName === 'Hospital Representative (Doctor)') &&
                    showApprove &&
                    caseData.doctor_approval_status !== 'Approved' &&
                    caseData.doctor_approval_status !== 'Rejected' && (
                      <button
                        type="button"
                        className="btn mb-1 me-4 waves-effect waves-light btn-rounded btn-success position-relative"
                        onClick={handleApprove}
                        disabled={isApproving}
                      >
                        {isApproving ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Approving...
                          </>
                        ) : (
                          'Approve'
                        )}
                      </button>
                    )}

                  {(userRoleName === 'Hospital Representative (Doctor)') &&
                    showReject &&
                    caseData.doctor_approval_status !== 'Approved' &&
                    caseData.doctor_approval_status !== 'Rejected' && (
                      <button
                        type="button"
                        className="btn mb-1 me-4 waves-effect waves-light btn-rounded btn-danger"
                        onClick={() => setShowRejectionModal(true)}
                        disabled={isRejecting}
                      >
                        {isRejecting ? 'Rejecting...' : 'Reject'}
                      </button>
                    )}
                </div>
              </div>
              </>
              )}
            </div>
          </div>

          {/* Document Modal */}
          <div
            className={`modal fade ${showDocumentModal ? 'show d-block' : ''}`}
            id="document-modal"
            tabIndex="-1"
            aria-labelledby="documentModalLabel"
            aria-modal="true"
            role="dialog"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Attachment</h4>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDocumentModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  {selectedDocument && renderDocumentContent(selectedDocument)}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn bg-danger-subtle text-danger"
                    onClick={() => setShowDocumentModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Patient Situation Modal */}
          <PatientSituationtransfercaseModal
            isOpen={isPatientModalOpen}
            onClose={() => setIsPatientModalOpen(false)}
            caseId={caseId}
            onSave={handlePatientModalSave}
          />

          {/* Rejection Modal */}
          <RejectionModal
            isOpen={showRejectionModal}
            onClose={() => setShowRejectionModal(false)}
            onSubmit={handleReject}
          />
        </div>
      </div>
    </div>
  </div>

  ); 
};

export default TransferDetailsTab;
